import { FC, useEffect, useRef } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { IngredientType, useBeautyService } from '../../services/useBeautyService';
import { GroupItem, IngredientGroupItem } from './IngredientGroupItem';

const INGREDIENT_TYPES = {
  primary: {
    title: '이 제품의 추천 성분을 확인해 보세요.',
    color: vars.v3Color.skyBlue200,
  },
  warning: {
    title: '이 제품의 주의 성분을 확인해 보세요.',
    color: vars.v3Color.yellow200,
  },
};

const TABS_HEIGHT = 49;

interface Props {
  type: IngredientType;
  groupList: GroupItem[];
}

export const IngredientGroup: FC<React.PropsWithChildren<Props>> = ({ type, groupList }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { title, color } = INGREDIENT_TYPES[type];

  const { activeIngredientItem, updateActiveIngredientItem } = useBeautyService();
  const activeIdx = activeIngredientItem[type];

  const handleItemClick = (idx: number) => () => {
    const updateIdx = activeIdx === idx ? -1 : idx;
    updateActiveIngredientItem(type, updateIdx);
  };

  useEffect(() => {
    const isActiveGroup = activeIdx > -1 && ref.current && typeof window !== 'undefined';
    if (!isActiveGroup) {
      return;
    }
    const top = window.scrollY + ref.current.getBoundingClientRect().top - TABS_HEIGHT;
    const timer = setTimeout(() => {
      window.scrollTo({ top, behavior: 'smooth' });
    }, 150);
    return () => clearTimeout(timer);
  }, [activeIdx]);

  return (
    <Root ref={ref}>
      <Title>
        <p className={Typography.BODY_18_SEMIBOLD}>{title}</p>
      </Title>
      <ul>
        {groupList.map((item, idx) => (
          <IngredientGroupItem
            key={item.description}
            item={{ ...item, color, rank: idx + 1 }}
            isActive={activeIdx === idx}
            onClick={handleItemClick(idx)}
          />
        ))}
      </ul>
    </Root>
  );
};

const Root = styled.div`
  padding: 20px 16px;
`;

const Title = styled.div`
  padding: 12px 0;
`;
